/* global axios */
import ApiClient from './ApiClient';

export default class PermissionSetsAPI extends ApiClient {
  constructor(accountId) {
    super(`accounts/${accountId}/permission_sets`);
  }

  catalog() {
    return axios.get(`${this.url}/permission_catalog`);
  }
}
